<template>

  <a
    href="javascript:void(0)"
    class="list-group-item list-group-item-action"
    @click="showEmail(email._id)"
    style="color: inherit;"
    :class="{'active': email._id === emailId}">
    <small style="float: right;">{{ $d(new Date(email.created_at), 'short') }}</small>
    <div :style="{'font-weight': email.read?'normal':'bold'}">
      <div>{{ displayName }}</div>
      <div>{{ email.subject }}</div>
      <div
        class="alert alert-danger mt-2"
        v-if="email.delivery_notification === 'bounce'">
        <b>Message not delivered.</b> There was a problem delivering your message.
      </div>
      <div
        class="alert alert-danger mt-2"
        v-if="email.delivery_status === 'failed'">
        <b>Your message was not sent.</b> An error occurred while trying to send your message
      </div>
    </div>
    <div class="subtext">{{ email.shurttext }}</div>
    <div
      class="mt-2 text-warning"
      v-if="email.delivery_status === 'scheduled'">
      <i class="fas fa-clock" /> <b>{{ $d(new Date(email.send_at), 'long') }}</b>
    </div>
  </a>

</template>

<script>
export default {
  name: 'EmailList',
  components: {
  },
  props: {
    email: {
      type: Object
    }
  },
  data () {
    return {
    }
  },
  computed: {
    emailId () {
      return this.$route.query.email_id
    },
    displayName () {
      const from = [
        ...(this.email.to || []),
        ...(this.email.cc || []),
        ...(this.email.bbc || [])
      ].map(v => v.name).slice(0, 2).join(', ')

      return this.email.type === 'sent' ? from : this.email.from.name
    }
  },
  created () {
  },
  methods: {
    /*
    showEmail
    */
    showEmail (emailId) {
      this.$changeUrlParam({ email_id: emailId })
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.active {
  background: #cce5ff;
  border-color: #cce5ff;
}
</style>



// WEBPACK FOOTER //
// src/components/Email/EmailListItem.vue